export enum ProjectType {
  OWNED = "OWNED",
  NOT_OWNED = "NOT_OWNED",
  COLLABORATION = "COLLABORATION",
}
